import React from 'react';
import {
  reduxForm,
  Field,
  FieldArray,
  getFormValues,
  change,
} from 'redux-form';
import { connect } from 'react-redux';
import LabelSection from 'components/sections/LabelSection';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import BankTypeField from 'components/Fields/ReduxForm/BankTypeField';
import {
  showModalConfirmSaveAll,
  showModalAssignOutlets,
  onClickCancelAddBank,
} from 'actions/setting/bankAccount';
import { find, reject } from 'lodash';
import SettingLetter from '../../../../components/Fields/ReduxForm/SettingLetter';
import styles from './FormBank.css';

const validate = values => {
  const errors = {};
  if (values.accountNumber || values.bankName || values.accountHolderName) {
    if (!values.accountNumber) {
      errors.accountNumber = 'This field is required';
    }
    if (!values.accountHolderName || values.accountHolderName.trim() === '') {
      errors.accountHolderName = 'This field is required';
    } else if (!/^[A-Za-z ]+$/.test(values.accountHolderName)) {
      errors.accountHolderName =
        'This field must contains letters and spaces only';
    }
    if (!values.bankName) {
      errors.bankName = 'This field is required';
    }
  } else {
    if (typeof values.bankName === 'undefined') {
      errors.bankName = 'This field is required';
    }
    if (typeof values.accountNumber === 'undefined') {
      errors.accountNumber = 'This field is required';
    }
    if (typeof values.accountHolderName === 'undefined') {
      errors.accountHolderName = 'This field is required';
    }
  }
  return errors;
};

class Form extends React.Component {
  render() {
    const { handleSubmit } = this.props;
    const { banks } = this.props;
    return (
      <form className={styles.wrapper}>
        <div className={`${styles['field-wrapper']}`}>
          <div className="row">
            <div className="col-sm-12 form-group">
              <LabelSection title="bank account information" />
              <Field
                component={BankTypeField}
                name="bankName"
                banks={banks}
                onChangeValue={e => {
                  const bank = find(banks, o => {
                    return o.name === e.target.value;
                  });
                  this.props.dispatch(
                    change('bankAccount', 'bankName', e.target.value)
                  );
                  this.props.dispatch(change('bankAccount', 'bankId', bank.id));
                }}
              />
              <Field component="hidden" name="bankId" />
            </div>
            <div className="col-sm-12 form-group">
              <Field
                component={SettingField}
                name="accountNumber"
                className="form-control"
                placeholder="Account Number"
                positiveNumberOnly
                maxFractionDigits={0}
                maxLength="25"
              />
            </div>
            <div className="col-sm-12 form-group">
              <Field
                component={SettingLetter}
                name="accountHolderName"
                className="form-control"
                placeholder="Account Holder Name"
                maxLength="255"
                letterOnly
              />
            </div>
            <div className="col-sm-12 form-group">
              <LabelSection title="assign outlets" />
              <FieldArray
                name="outlets"
                component={this._renderAssignedOutlets}
              />
              <FieldArray name="unlinkOutlets" component="hidden" />
              <button
                className={`btn btn-primary mt-20px ${
                  styles['btn-assignOutlet']
                }`}
                onClick={this._onClickAssignOutlet}
              >
                Assign Outlet
              </button>
              <div className={styles['label-track-item']}>
                <i
                  className={`fa fa-exclamation-circle ${styles['info-icon']}`}
                />
                <label>
                  This account is being used for mobile payment settlement
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              disabled={
                !(
                  this.props.addBankForm !== undefined &&
                  this.props.addBankForm.outlets !== undefined &&
                  this.props.addBankForm.outlets.length > 0
                )
              }
              onClick={handleSubmit(this._onClickSaveBank)}
            >
              Save
            </button>
          </span>
        </div>
      </form>
    );
  }

  _onClickAssignOutlet = e => {
    this.props.dispatch(showModalAssignOutlets());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickCancel = e => {
    this.props.dispatch(onClickCancelAddBank());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickSaveBank = values => {
    const { onSubmit } = this.props;
    onSubmit(values);
  };

  _onClickSavetoAll = () => {
    this.props.dispatch(showModalConfirmSaveAll());
  };

  _renderAssignedOutlets = ({ fields }) => {
    return (
      <div className="row">
        {fields.map((...props) => {
          const [, index] = props;
          const field = fields.get(index);

          return (
            <div className="col-sm-12" key={index}>
              {field.name}
            </div>
          );
        })}
      </div>
    );
  };

  _isDisableSaveToAll = () => {
    const { rightColumnType, outletStatus, bankAccountDetail } = this.props;
    if (rightColumnType === 'form') {
      return outletStatus.length !== 0;
    }
    if (rightColumnType === 'edit') {
      const outlets = reject(outletStatus, [
        'bankAccId',
        bankAccountDetail.bankAccId,
      ]);
      return outlets.length !== 0;
    }
  };
}

const mapForm = {
  form: 'bankAccount',
  touchOnBlur: false,
  touchOnChange: true,
  destroyOnUnmount: false,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true,
  validate,
};

function mapStateToProps(state) {
  const {
    rightColumnType,
    bankAccountDetail,
    outletStatus,
  } = state.setting.bankAccount;
  return {
    initialValues: {
      bankName: bankAccountDetail ? bankAccountDetail.bankName : undefined,
      bankId: bankAccountDetail ? bankAccountDetail.bankId : undefined,
      bankAccId: bankAccountDetail ? bankAccountDetail.bankAccId : undefined,
      accountNumber: bankAccountDetail
        ? bankAccountDetail.accountNumber
        : undefined,
      accountHolderName: bankAccountDetail
        ? bankAccountDetail.accountHolderName
        : undefined,
      outlets: bankAccountDetail ? bankAccountDetail.outlets : [],
    },
    addBankForm: getFormValues('bankAccount')(state),
    bankAccountDetail,
    rightColumnType,
    outletStatus,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

let formBank = reduxForm(mapForm)(Form);
formBank = connect(
  mapStateToProps,
  mapDispatchToProps
)(formBank);
export default formBank;
